var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{staticClass:"btn--primary",attrs:{"text":_vm.text},on:{"click-button":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }